import { requests } from "utils";
import { URL } from "./constants";

const textHeader = new Headers({
  "Content-Type": "text/plain",
});
export function fetchMenuItemsRequest() {
  return requests.get(URL, textHeader, true);
}
